import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import axios from 'axios';
import { TABLE_DATA_CACHE, GEO_LOCATION_CACHE } from 'app/cache/cacheSettings';
import { getJSONFromLocalStorage } from 'app/util/localStorageUtils';

export const favouriteBooking = (row) => {

    const selectRow = (row) => {
        row.isFavourite = !row.isFavourite;
        if (row.isFavourite === true) {
            try {
                const addFavouriteBooking = async () => {
                    await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/AddFavouriteBooking`, { isFavouriteBooking: true, bookingId: row.shipmentID })
                        .then((resp) => {
                            cacheRow(TABLE_DATA_CACHE.key, row.isFavourite);
                            cacheRow(GEO_LOCATION_CACHE.key, row.isFavourite);
                        });
                }
                addFavouriteBooking();
            } catch (error) {
                if (error.response) {
                    console.error(`An error occured whilst adding a favourite booking. Status: ${error.response.status}. Detail from server: ${error.response.data.detail}.`);
                }
            }
        }
        else {
            try {
                const deleteFavouriteBooking = async () => {
                    await axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/DeleteFavouriteBooking`, {
                        params: {
                            bookingId: row.shipmentID
                        }
                    }).then((resp) => {
                        cacheRow(TABLE_DATA_CACHE.key, row.isFavourite);
                        cacheRow(GEO_LOCATION_CACHE.key, row.isFavourite);
                    });
                }
                deleteFavouriteBooking();
            } catch (error) {
                if (error.response) {
                    console.error(`An error occured whilst deleting a favourite booking. Status: ${error.response.status}. Detail from server: ${error.response.data.detail}.`);
                }
            }
        } 
    };

    const renderIcon = () => {
        if (row.isFavourite) {
            return <StarIcon onClick={() => selectRow(row)}
                sx={{
                    fontSize: 30,
                    color: '#FFB81C',
                    cursor: 'pointer'
                }}
            />
        }

        return <StarBorderIcon onClick={() => selectRow(row)}
            sx={{
                fontSize: 30,
                color: '#FFB81C',
                cursor: 'pointer'
            }}
        />
    };

    const cacheRow = (key, isFavourite) => {
        var cache = getJSONFromLocalStorage(key);
        if (cache && cache.value.webPortalAirSeaBookings.length > 0) {
            var cachedWebPortalAirSeaBookings = cache.value.webPortalAirSeaBookings;
            var cachedRow = cachedWebPortalAirSeaBookings.find((booking) => { return booking.shipmentID === row.shipmentID })
            if (cachedRow) {
                cachedRow.isFavourite = isFavourite;
                localStorage.setItem(key, JSON.stringify(cache));
            }
        }
    };

    return (
            renderIcon()
        )
};